import { useConfigurationNavigationApi } from "@plansoft-configuration-renderer/framework";
import { useConfigurationMeta } from "@plansoft-configuration-renderer/framework";
import { useConfigurationAttributeParents } from "../../NavigationState/useConfigurationAttributeParents";
export function useConfigurationTypeCodeElement(element) {
    const { baseUrl: basePath } = useConfigurationMeta();
    const { objectPath, attributeId } = element;
    if (objectPath == null || attributeId == null) {
        throw new Error("ConfigurationTypeCodeElement is missing objectPath or attributeId");
    }
    const items = useConfigurationAttributeParents({
        configurationObjectPath: objectPath,
        attributeId,
        basePath,
    });
    const { setItems } = useConfigurationNavigationApi();
    return {
        elementExists: items.length > 0,
        handleElementClick: (e) => {
            e.preventDefault();
            setItems(items);
        },
    };
}
//# sourceMappingURL=useConfigurationTypeCodeElement.js.map